// extracted by mini-css-extract-plugin
export default {"categoryEdit":"category-edit_categoryEdit__JA65v","categoryEditContent":"category-edit_categoryEditContent__UwtvE"};